// src/components/PrivateRoute.tsx
import React, { useEffect } from 'react';
import { Route, Navigate, RouteProps } from 'react-router-dom';
import { useAuthCheck } from '../hooks/useAuthCheck';

interface PrivateRouteProps {
    children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    useAuthCheck();

    return <>{children}</>;
};

export default PrivateRoute;
